import { BASE_SERVICE_URL } from '../lib/constants'

export default function uploadModel(eventType, uid, fileName, sheetIndex, date) {
    let data = new FormData()
    data.append('uid', uid)
    data.append('fileName', fileName)
    data.append('sheetIndex', sheetIndex)
    data.append('eventType', eventType)
    data.append('dateReference', date)
    data.append('username', window.Live.authorization.user.username)

    return fetch(BASE_SERVICE_URL + `/models/upload/${eventType}`, {
        credentials: 'same-origin',
        method: 'POST',
        body: data
    }).then(response => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)
            error.response = response
            throw error
        }
    })
}
